export default __webpack_public_path__ + "economies_meb9273.png";